export const version = '1.0.5';
//# sourceMappingURL=version.js.map